import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { Col, Grid, Row } from 'react-bootstrap'
import { AmbassadorSection } from '../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import { SectionTitle } from '../../../../../../Components/Section/SectionTitle'
import {
  MISSION_ENUM_TYPES,
  MISSION_STATUS_ENUM,
} from '../../../../../../shared/constants'
import { theme } from 'Assets/Styles/theme'
import { StarRating } from '../../../../../../Components/StarRating'

const getMissionsStatistic = missions => {
  let date = null

  const result = missions.reduce(
    (acc, mission) => {
      if (
        mission.status === MISSION_STATUS_ENUM.COMPLETED ||
        mission.status === MISSION_STATUS_ENUM.PAID
      ) {
        acc.missionCompleted += 1
        acc.flyersDistributed += mission.totalFlyersDistributed
        if (new Date(mission.timeRangeStart) > new Date(date)) {
          date = mission.timeRangeStart
        }
      }
      return acc
    },
    {
      lastMissionDate: null,
      missionCompleted: 0,
      flyersDistributed: 0,
    },
  )

  return {
    ...result,
    lastMissionDate: date ? moment(date).format('DD MMMM YYYY') : 'N/A',
  }
}

const Column = ({ children, title, xs = 3 }) => (
  <Col
    xs={xs}
    style={{
      padding: 0,
      textAlign: 'center',
      color: title ? theme.colors.regentGray : 'inherit',
      display: 'flex',
    }}
  >
    {children}
  </Col>
)

const AmbassadorStatisticsSection = ({
  ambassador,
  missions,
  isLoadedMissions,
}) => {
  const [handToHandStatistic, setHandToHandStatistic] = useState({
    lastMissionDate: 'Loading...',
    missionCompleted: 'Loading...',
    flyersDistributed: 'Loading...',
  })
  const [letterboxStatistic, setLetterboxStatistic] = useState({
    lastMissionDate: 'Loading...',
    missionCompleted: 'Loading...',
    flyersDistributed: 'Loading...',
  })

  const { letterboxMissions, handToHandMissions } = missions.reduce(
    (acc, mission) => {
      if (mission.type === MISSION_ENUM_TYPES.HANDTOHAND) {
        acc.handToHandMissions.push(mission)
      }
      if (mission.type === MISSION_ENUM_TYPES.LETTERBOX) {
        acc.letterboxMissions.push(mission)
      }

      return acc
    },
    {
      letterboxMissions: [],
      handToHandMissions: [],
    },
  )

  useEffect(() => {
    if (isLoadedMissions) {
      setHandToHandStatistic(getMissionsStatistic(handToHandMissions))
      setLetterboxStatistic(getMissionsStatistic(letterboxMissions))
    }
  }, [isLoadedMissions])

  const { rating } = ambassador

  return (
    <AmbassadorSection className="statistics">
      <Grid fluid>
        <Row>
          <Col xs={12} style={{ marginBottom: 15 }}>
            <SectionTitle style={{ marginBottom: 0 }}>Statistics</SectionTitle>
          </Col>
        </Row>
        <Row xs={12} style={{ display: 'flex', alignItems: 'center' }}>
          <Col
            xs={12}
            style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}
          >
            <div style={{ marginRight: 10 }}>BA missions’ rating:</div>
            <StarRating score={rating} uniqueId="D30-letterbox" />
          </Col>
        </Row>
        <Row xs={12} style={{ marginLeft: 0 }}>
          <Column />
          <Column title>Last Completed Mission</Column>
          <Column title># Flyers Distributed</Column>
          <Column title>Missions Completed</Column>
          <Column />
        </Row>
        <Row xs={12} style={{ marginLeft: 0 }}>
          <Column title>Hand to Hand</Column>
          <Column>{handToHandStatistic.lastMissionDate}</Column>
          <Column>{handToHandStatistic.flyersDistributed}</Column>
          <Column>{handToHandStatistic.missionCompleted}</Column>
          <Column />
        </Row>
        <Row xs={12} style={{ marginLeft: 0 }}>
          <Column title>Letterbox</Column>
          <Column>{letterboxStatistic.lastMissionDate}</Column>
          <Column>{letterboxStatistic.flyersDistributed}</Column>
          <Column>{letterboxStatistic.missionCompleted}</Column>
          <Column />
        </Row>
      </Grid>
    </AmbassadorSection>
  )
}

export default AmbassadorStatisticsSection
